import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.2702 19.294C15.7372 18.381 16.1172 17.279 16.3792 16.042H18.8922C18.0532 17.467 16.7892 18.61 15.2702 19.294ZM5.1082 16.042H7.6212C7.8832 17.279 8.2632 18.381 8.7302 19.294C7.2112 18.61 5.9472 17.467 5.1082 16.042ZM8.7302 4.706C8.2522 5.64 7.8642 6.77 7.6012 8.042H5.0572C5.8952 6.577 7.1822 5.403 8.7302 4.706ZM12.0002 4.123C12.4812 4.123 13.5982 5.461 14.2232 8.042H9.7772C10.4022 5.461 11.5192 4.123 12.0002 4.123ZM4.0002 12C4.0002 11.323 4.0932 10.67 4.2522 10.042H7.3032C7.2432 10.675 7.2092 11.329 7.2092 12C7.2092 12.7 7.2452 13.382 7.3102 14.042H4.2742C4.1012 13.389 4.0002 12.706 4.0002 12ZM9.4462 14.042C9.3762 13.409 9.3332 12.732 9.3332 12C9.3332 11.301 9.3722 10.65 9.4362 10.042H14.5642C14.6282 10.65 14.6672 11.301 14.6672 12C14.6672 12.732 14.6242 13.409 14.5542 14.042H9.4462ZM12.0002 19.877C11.5242 19.877 10.4252 18.568 9.7962 16.042H14.2042C13.5752 18.568 12.4762 19.877 12.0002 19.877ZM20.0002 12C20.0002 12.706 19.8992 13.389 19.7262 14.042H16.6892C16.7552 13.382 16.7902 12.7 16.7902 12C16.7902 11.329 16.7572 10.675 16.6972 10.042H19.7482C19.9062 10.67 20.0002 11.323 20.0002 12ZM18.9432 8.042H16.3982C16.1352 6.77 15.7482 5.64 15.2702 4.706C16.8182 5.403 18.1042 6.577 18.9432 8.042ZM12.0002 2C6.4772 2 2.0002 6.477 2.0002 12C2.0002 17.523 6.4772 22 12.0002 22C17.5232 22 22.0002 17.523 22.0002 12C22.0002 6.477 17.5232 2 12.0002 2Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconGlobe = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconGlobe.displayName = "IconGlobe";

export { IconGlobe };
